"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../../lib/mathquill.min");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MQ = MathQuill.getInterface(2);

var MathquillMenuSymbol = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MathquillMenuSymbol, _React$PureComponent);

  var _super = _createSuper(MathquillMenuSymbol);

  function MathquillMenuSymbol() {
    var _this;

    _classCallCheck(this, MathquillMenuSymbol);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onSymbolClicked", function () {
      var _this2;

      return (_this2 = _this).__onSymbolClicked__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    return _this;
  }

  _createClass(MathquillMenuSymbol, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var mathField = MQ.StaticMath(this.iconElm);
      mathField.reflow();

      if (this.props.focus) {
        this.btnElm.focus();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.focus) {
        this.btnElm.focus();
      }
    }
  }, {
    key: "__onSymbolClicked__REACT_HOT_LOADER__",
    value: function __onSymbolClicked__REACT_HOT_LOADER__() {
      var _this$props = this.props,
          symbolClickHandler = _this$props.symbolClickHandler,
          symbolData = _this$props.symbolData;

      if (typeof symbolClickHandler === 'function') {
        symbolClickHandler(symbolData);
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var symbolData = this.props.symbolData;
      return /*#__PURE__*/_react.default.createElement("button", {
        "aria-label": symbolData.title,
        onClick: this.onSymbolClicked,
        ref: function ref(btn) {
          _this3.btnElm = btn;
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: symbolData.icon
        },
        ref: function ref(el) {
          _this3.iconElm = el;
        }
      }));
    }
  }]);

  return MathquillMenuSymbol;
}(_react.default.PureComponent);

_defineProperty(MathquillMenuSymbol, "propTypes", {
  focus: _propTypes.default.bool.isRequired,
  symbolData: _propTypes.default.object,
  symbolClickHandler: _propTypes.default.func
});

var _default = MathquillMenuSymbol;
var _default2 = _default;
exports.default = _default2;
module.exports = exports["default"];
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MQ, "MQ", "/opt/TeamCity/buildAgent2/work/63f390c34456f15a/src/js/components/MathquillMenuSymbol.js");

  __REACT_HOT_LOADER__.register(MathquillMenuSymbol, "MathquillMenuSymbol", "/opt/TeamCity/buildAgent2/work/63f390c34456f15a/src/js/components/MathquillMenuSymbol.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/opt/TeamCity/buildAgent2/work/63f390c34456f15a/src/js/components/MathquillMenuSymbol.js");
}();

;